<template>

    <div class="input-group input-group-sm">
        <input type="text" class="form-control" v-model="value" :disabled="!canEdit" />
        <span class="input-group-btn">
            <button v-show="!editing" type="button" class="btn btn-info" @click="editing = true"><i class="mdi mdi-pencil"></i></button>
            <button v-show="editing" type="button" :disabled="!canEdit" class="btn btn-info" @click="saveFunction"><i class="mdi mdi-content-save"></i></button>
        </span>
    </div>

</template>

<script>

    import axios from 'axios';

    export default {

        computed: {
            canEdit() {
                return this.editing === true &&
                    false === this.processing;
            },
        },

        data() {
            return {
                editing:false,
                processing:false,
                value:'',
            }
        },

        methods: {
            saveFunction(){
                this.processing = true;
                axios.patch(this.url, {function: this.value})
                .then(() => {
                    this.$snotify.success("Functie is opgeslagen");
                    this.editing = false;
                })
                .catch(() => this.$snotify.error("Er is een fout opgetreden bij het opslaan van de functie!"))
                .finally(() => this.processing = false);
            },
        },

        mounted() {
            this.value = JSON.parse(JSON.stringify(this.current));
        },

        name: "CrmCompanyFunction",

        props: {
            current: { required: true },
            url: { required: true },
        }

    }

</script>
